module.exports = __webpack_public_path__ + "static/img/guide-17.271dca08.png";